<template>
    <b-form-group :invalid-feedback="invalidFeedback" :label="label" :label-for="formControlId">
        <b-form-radio-group :id="formControlId" v-model="data[property]" :buttons="buttons"
            :disabled="isReadOnlyProperty"
            :name="formControlId" :options="options" :required="isRequiredProperty" :stacked="stacked"
            :state="validationState" @change="handleChange"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from '@components/form/FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            buttons: {
                type: Boolean,
                default: false,
            },
            options: {
                type: Array,
                required: true,
            },
            stacked: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        methods: {
            handleChange(value) {
                this.$emit('change', value);
            },
        },
    }
</script>
